import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
  faPlus,
  faStar,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { useLanguageContext } from "../../../../context/LanguageContext";
import Modal from "../../../modal/Modal";
import {
  StyledAltButton,
  StyledAltIconButton,
  StyledButton,
  StyledTextButton,
} from "../../../../styles/ButtonStyles";
import {
  StyledSettings,
  StyledSettingsColumns,
  StyledSettingsItem,
  StyledSettingsWrapper,
} from "../DataTableStyles";
import { StyledInput } from "../../../../styles/InputStyles";
import Form from "../../../form/Form";
import InputWrapper from "../../../input/wrapper/InputWrapper";
import Checkbox from "../../../input/checkbox/Checkbox";
import { useTheme } from "styled-components";
import { StyledFlexColumn } from "../../../../styles/LayoutStyles";
import HiddenLoader from "../../../loader/HiddenLoader/HiddenLoader";

function SavedFiltersView({
  controller,
  savedFilters,
  activeFilter,
  saveModalOpen,
  modalData,
  setModalData,
  onLoadFilter,
  onToggleDefault,
  onDeleteFilter,
  onOpenSaveModal,
  onCloseSaveModal,
  onSaveFilter,
}) {
  const theme = useTheme();
  const { translate } = useLanguageContext();

  return (
    <>
      {/* Saved filters dropdown */}
      <StyledSettingsWrapper>
        <HiddenLoader
          groups={`datatable-${controller.config.getDataTableKey()}-saved-filters-fetch`}
        >
          <StyledAltIconButton
            ref={controller.savedFiltersDropdown.buttonRef}
            onClick={() =>
              controller.savedFiltersDropdown.setOpen((open) => !open)
            }
            title={translate("eva.main.entities.saved_filters")}
            style={{
              border: activeFilter
                ? `1px solid ${theme.colors.accent.normal}`
                : undefined,
            }}
          >
            <FontAwesomeIcon icon={faFilter} />
          </StyledAltIconButton>
        </HiddenLoader>

        {controller.savedFiltersDropdown.open && (
          <StyledSettings
            ref={controller.savedFiltersDropdown.dropdownRef}
            style={{ left: 0, right: "initial" }}
          >
            {savedFilters.length > 0 && (
              <StyledSettingsColumns>
                {savedFilters.map((savedFilter) => (
                  <StyledSettingsItem key={savedFilter.id}>
                    <StyledAltButton
                      style={{
                        flex: 1,
                        textAlign: "left",
                        border:
                          activeFilter === savedFilter.id
                            ? `1px solid ${theme.colors.accent.normal}`
                            : undefined,
                      }}
                      onClick={() => onLoadFilter(savedFilter)}
                    >
                      {savedFilter.name}
                    </StyledAltButton>

                    <StyledTextButton
                      onClick={() => onToggleDefault(savedFilter)}
                      title={translate("eva.main.general.default")}
                      style={{
                        color: savedFilter.default
                          ? theme.colors.accent.normal
                          : `rgba(${theme.colors.on.primaryRGB}, 0.2)`,
                      }}
                    >
                      <FontAwesomeIcon icon={faStar} />
                    </StyledTextButton>

                    <HiddenLoader
                      groups={`datatable-${controller.config.getDataTableKey()}-saved-filters-delete-${savedFilter.id}`}
                    >
                      <StyledAltIconButton
                        onClick={() => onDeleteFilter(savedFilter)}
                        title={translate("eva.main.entities.states.delete", [
                          {
                            key: "entities",
                            value: translate("eva.main.entities.saved_filters"),
                          },
                        ])}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </StyledAltIconButton>
                    </HiddenLoader>
                  </StyledSettingsItem>
                ))}
              </StyledSettingsColumns>
            )}

            {/* Add filter button */}
            <StyledAltIconButton
              onClick={onOpenSaveModal}
              style={{
                display: "block",
                margin: theme.spacing.normal,
              }}
              title={translate("eva.main.entities.states.create", [
                {
                  key: "entities",
                  value: translate("eva.main.entities.saved_filter"),
                },
              ])}
            >
              <FontAwesomeIcon icon={faPlus} />
            </StyledAltIconButton>
          </StyledSettings>
        )}
      </StyledSettingsWrapper>

      {/* Save filter modal */}
      {saveModalOpen && (
        <Modal
          onClose={onCloseSaveModal}
          title={translate("eva.main.entities.states.create", [
            {
              key: "entities",
              value: translate("eva.main.entities.saved_filter"),
            },
          ])}
        >
          <StyledFlexColumn
            as={Form}
            onSubmit={onSaveFilter}
            loadingGroups={`datatable-${controller.config.getDataTableKey()}-saved-filters-save`}
          >
            <InputWrapper
              label={translate("eva.main.validation.attributes.name")}
              required
            >
              <StyledInput
                type="text"
                placeholder={translate("eva.main.validation.attributes.name")}
                value={modalData.name}
                onChange={(e) =>
                  setModalData((prev) => ({ ...prev, name: e.target.value }))
                }
              />
            </InputWrapper>

            <InputWrapper
              label={translate("eva.main.validation.attributes.default")}
            >
              <Checkbox
                value={modalData.default}
                onChange={(value) =>
                  setModalData((prev) => ({ ...prev, default: value }))
                }
              />
            </InputWrapper>

            <HiddenLoader
              groups={`datatable-${controller.config.getDataTableKey()}-saved-filters-save`}
              containerStyle={{
                display: "inline",
                width: "fit-content",
              }}
            >
              <StyledButton
                type="submit"
                style={{
                  marginTop: theme.spacing.large,
                }}
              >
                {translate("eva.main.general.save")}
              </StyledButton>
            </HiddenLoader>
          </StyledFlexColumn>
        </Modal>
      )}
    </>
  );
}

export default SavedFiltersView;
